/* eslint-disable react/prop-types */

import React from "react";
import _ from "underscore";
import SortIcon from "images/sprites/reb/svg/sort_icon.svg";

/**
 * Only used in SortDropdown in GridTopFilters, don't use as an atomic component
 * @deprecated
 */
class SpecialSelect extends React.Component {
  getValue = () => {
    return this.props.selected || Object.keys(this.props.sorts)[0];
  };

  getLabel = () => {
    return this.props.defaultLabel ? this.props.defaultLabel : this.props.sorts[this.getValue()];
  };

  onChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };

  render() {
    return (
      //Yes this mixes tailwind and legacy CSS, but this component is slated for removal
      //The new grid designs no longer have this select element and I don't want to do a full rewrite
      <div
        id={this.props.id + "-wrapper"}
        className="flex items-center h-8 m-1 px-3 relative sort-dropdown rounded-3xl normal-case text-sm bg-offWhite cursor-pointer">
        <label className="mb-0 normal-case text-sm tracking-normal flex items-center" htmlFor={this.props.id}>
          <SortIcon className="mr-2" />
          {this.getLabel()}
        </label>
        <select
          readOnly={true}
          className="special-select-select"
          id={this.props.id}
          name={this.props.name}
          value={this.getValue()}
          onChange={this.onChange}>
          {_.map(this.props.sorts, function (val, key) {
            return (
              <option key={key} value={key}>
                {val}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

export default SpecialSelect;
